import React, { useState } from 'react';
import { Button, Divider, List, ListItem, ListItemSecondaryAction, ListItemText, Popover, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FileChooser from '../../fileChooser/components/FileChooser';
var ACCEPTED_FILE_TYPES = '.xls,.xlsx';
var MAX_FILE_SIZE = 10485760; // 10MB
export var ListImportPopover = function (_a) {
    var listTitle = _a.listTitle, anchorEl = _a.anchorEl, onClose = _a.onClose, onImport = _a.onImport, _b = _a.partialImportOnly, partialImportOnly = _b === void 0 ? false : _b, droppedFile = _a.droppedFile;
    var _c = useState(droppedFile), file = _c[0], setFile = _c[1];
    var _d = useState(true), partialImport = _d[0], setPartialImport = _d[1];
    var t = useTranslation().t;
    var handleImport = function (e) {
        if (file) {
            onImport({ file: file, partialImport: partialImport }, e);
        }
        else {
            console.error('No File selected, cannot import!');
        }
    };
    var handleFileSelection = function (fileList) {
        setFile(fileList[0]);
    };
    return (React.createElement(Popover, { open: true, anchorEl: anchorEl, onClose: onClose, container: document.getElementById('appContainer'), anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' } },
        React.createElement(List, { className: "listPopover" },
            React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listImport.header', { listTitle: listTitle }), className: "listPopover__header" })),
            React.createElement(Divider, null),
            React.createElement(FileChooser, { name: 'importFile', label: t('listImport.uploadFile'), files: file ? [file] : [], onFileSelection: handleFileSelection, accept: ACCEPTED_FILE_TYPES, sizeRestriction: MAX_FILE_SIZE, multiple: false }),
            React.createElement(Divider, null),
            React.createElement(ListItem, null,
                React.createElement(ListItemText, { primary: t('listImport.partialImport') }),
                React.createElement(ListItemSecondaryAction, null,
                    React.createElement(Switch, { color: "primary", onChange: function () { return setPartialImport(!partialImport); }, checked: partialImport, disabled: partialImportOnly }))),
            React.createElement(ListItem, { className: "listPopover__actionButtons" },
                React.createElement(Button, { color: "secondary", onClick: onClose }, t('listImport.cancel')),
                React.createElement(Button, { disabled: !file, color: "primary", onClick: handleImport }, t('listImport.import'))))));
};
export default ListImportPopover;
//# sourceMappingURL=ListImportPopover.js.map